// import Helpers from '../modules/helpers';

const StickyNav = {
    bindEvents: () => {
        const sticky = document.getElementById('sticky');
        if (sticky) {
            StickyNav.init(sticky);
        }
    },

    init: (sticky) => {
        let scrollProgress = document.getElementsByClassName('sib-nav__scroll-progress');
        document.addEventListener('scroll', () => {
            StickyNav.checkStickyNavAndProgress(sticky, scrollProgress);
        });

        StickyNav.checkStickyNavAndProgress(sticky, scrollProgress);
    },

    checkStickyNavAndProgress: (sticky, progressBar) => {
        // safari doesn't like documentElement to get scrollTop.
        const elm = document.scrollingElement || document.documentElement;
        let currentScroll = elm.scrollTop;
        let relativeScroll = document.documentElement.scrollHeight - document.documentElement.clientHeight;
        let percentValue = Math.ceil((currentScroll / relativeScroll) * 100);
        let header = document.getElementById('header-container').clientHeight;

        let scrollThreshold = header;
        // if (document.getElementsByTagName('body')[0].classList.contains('page-cms-homepage')) {
        //     scrollThreshold = 500;
        // }
        // console.log(currentScroll);
        if (currentScroll > scrollThreshold) {
            sticky.classList.add('sticky--fixed');
        } else {
            sticky.classList.remove('sticky--fixed');
        }

        if (progressBar.length) {
            progressBar[0].style.width = `${percentValue}%`;
        }
    },
};

module.exports = StickyNav;



// WEBPACK FOOTER //
// ./src/js/partials/stickynav.js